import React, { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

import { ScheduleCalendar, SectionCard } from "components/admin";
import { workspaceApi } from "pages/app/workspace/services";
import { SchoolTeamProfileTabProps } from "pages/app/workspace/school-team-profile/school-team-profile.types";

export const SchoolTeamScheduleTab: React.FC<SchoolTeamProfileTabProps> = ({ team, teamId }) => {
  const dashboardQuery = useQuery({
    queryKey: ["school-team-profile-dashboard", teamId],
    queryFn: () => workspaceApi.schoolTeamDashboards.get(teamId),
    enabled: Boolean(teamId),
  });

  const upcomingMatches = useMemo(
    () => dashboardQuery.data?.match_week?.schedule || dashboardQuery.data?.upcoming_matches || [],
    [dashboardQuery.data?.match_week?.schedule, dashboardQuery.data?.upcoming_matches],
  );

  const teamCalendarItems = useMemo(
    () =>
      upcomingMatches.map((match: any) => ({
        category: "match" as const,
        details: [match.competition_name || match.match_type, match.result_summary]
          .filter(Boolean)
          .join(" | "),
        id: `team-match-${
          match.id || `${match.scheduled_at}-${match.competition_name || "fixture"}`
        }`,
        location: match.venue_name || match.venue_address || "Venue pending",
        start: match.scheduled_at,
        status: match.status || "scheduled",
        title:
          match.home_school_team?.name && match.away_school_team?.name
            ? `${match.home_school_team.name} vs ${match.away_school_team.name}`
            : match.competition_name || team?.name || "Team fixture",
      })),
    [team?.name, upcomingMatches],
  );

  return (
    <SectionCard title="Team Calendar">
      <ScheduleCalendar
        emptyDescription="This team’s upcoming schedule will appear here once fixtures are available."
        emptyTitle="No team schedule"
        isLoading={dashboardQuery.isLoading}
        items={teamCalendarItems}
      />
    </SectionCard>
  );
};
